<template>
  <div
    class="info-box"
    :class="{ 'info-box-vertical': vertical }"
    aria-hidden="true"
  >
    <KeyValuePair
      v-for="item in items"
      :key="item.id"
      :label="item.label"
      :value="item.value"
      :class="item.class"
      :loading="item.loading"
      inline
    >
      <template v-if="item.valueSlot" #value>
        <component :is="item.valueSlot" />
      </template>
    </KeyValuePair>
  </div>
</template>

<script lang="ts" setup>
import { ClassValue, PropType, toRefs } from 'vue';

import { VNodeArrayChildren, VNodeChildAtom } from '@rygen/rygen-ui/model';

import KeyValuePair from '@rygen/rygen-ui/components/ui/KeyValuePair.vue';

export interface InfoBoxItem {
  id: string;
  class?: ClassValue;
  label: string;
  value?: string | number;
  valueSlot?: () => VNodeChildAtom | VNodeArrayChildren;
  loading?: boolean;
}

const props = defineProps({
  items: {
    type: Array as PropType<InfoBoxItem[]>,
    default: () => [],
  },
  vertical: {
    type: Boolean,
    default: () => false,
  },
});
const { items } = toRefs(props);
</script>

<style>
:root {
  --info-box-gap: var(--gap-1);
  --info-box-label-font-weight: 600;
  --info-box-padding: var(--sp-1) var(--sp-2);
  --info-box-color: var(--p-surface-500);
  --info-box-background-color: var(--p-gray-100);
  --info-box-border-radius: var(--p-border-radius-sm);
  --info-box-separator: ': ';
}

.info-box {
  display: flex;
  gap: var(--info-box-gap);
  padding: var(--info-box-padding);
  color: var(--info-box-color);
  background-color: var(--info-box-background-color);
  border-radius: var(--info-box-border-radius);

  &.info-box-vertical {
    flex-direction: column;
  }

  .key-value-pair {
    .key-value-pair-label {
      font-weight: var(--info-box-label-font-weight);

      .label {
        &::after {
          content: var(--info-box-separator);
        }
      }
    }
  }
}
</style>
